import useDeleteApi from './useDeleteApi';
import { url } from '../../utils/confserveur';
export const useDeleteSequence = () => {
  const { deleteData, isLoadingDeleteSequence, errorDeleteSequence } = useDeleteApi();

  const deleteSequence = async (sequenceId) => {
    const urldelete = `${url}sequences/${sequenceId}/`;
    await deleteData(urldelete);
  };

  return { deleteSequence, isLoadingDeleteSequence, errorDeleteSequence };
};